import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Trans, withNamespaces } from 'react-i18next';
import config from '../../../../config';
import Fieldset from '../Fieldset';
import ActionBar from '../ActionBar';
import EditLink from './components/EditLink';
import { Content } from './styles';

function Summary({ t, kind, data, setData, steps, setCurrentStep, onSubmit }) {
  const [submitDisabled, disableSubmit] = useState(true);

  useEffect(() => {
    setData({ checkTOS: false });
    setData({ checkPaymentTerms: false });
  }, []);

  useEffect(() => {
    disableSubmit(!(data.checkTOS && data.checkPaymentTerms));
  }, [data.checkTOS, data.checkPaymentTerms]);

  function handleEdit(stepName) {
    setCurrentStep(steps.findIndex(step => step.name === stepName));
  }

  function handleCheck({ target: { name, checked } }) {
    setData({ [name]: checked });
  }

  function handleSubmit() {
    onSubmit();
    return true;
  }

  return (
    <div>
      <Content>
        <Fieldset legend={t('form.legends.customerInfo')}>
          <p>
            {t('form.companyFriendlyName.label')}:{' '}
            <em>{data.companyFriendlyName}</em>
          </p>
          <p>
            {t('form.legalOwnerName.label')}: <em>{data.legalOwnerName}</em>
          </p>
          <p>
            {t('form.outletType.label')}: <em>{data.outletType}</em>
          </p>
          <p>
            {t('form.contactName.label')}: <em>{data.contactName}</em>
          </p>
          <p>
            {t('form.contactPhone.label')}: <em>{data.contactPhone}</em>
          </p>
          <p>
            {t('form.contactEmail.label')}: <em>{data.contactEmail}</em>
          </p>
          <p>
            {t('form.season.label')} <em>{t('form.seasons.' + data.season)}</em>
          </p>

          {data.season === 'event' ? (
            <div>
              <p>{t('form.eventDatesMessage')}</p>
              <p>
                {t('form.eventStartDate.label')}: <em>{data.eventStartDate}</em>
              </p>
              <p>
                {t('form.eventEndDate.label')}: <em>{data.eventEndDate}</em>
              </p>
            </div>
          ) : null}

          <div className="text-right">
            <EditLink onClick={() => handleEdit('customer-info')} />
          </div>
        </Fieldset>

        <Fieldset legend={t('form.legends.deliveryInfo')}>
          <p>
            {t('form.deliveryAddress.label')}: <em>{data.deliveryAddress}</em>
          </p>
          <p>
            {t('form.deliveryZipCode.label')}: <em>{data.deliveryZipCode}</em>
          </p>
          <p>
            {t('form.deliveryCity.label')}: <em>{data.deliveryCity}</em>
          </p>

          <div className="text-right">
            <EditLink onClick={() => handleEdit('delivery-info')} />
          </div>
        </Fieldset>

        <Fieldset legend={t('form.legends.deliveryDate')}>
          <p>
            {t('form.deliveryDay.label')}:{' '}
            <em>
              {[
                'monday',
                'tuesday',
                'wednesday',
                'thursday',
                'friday',
                'saturday',
                'sunday'
              ].includes(data.deliveryDay)
                ? t('weekdays.' + data.deliveryDay)
                : ''}
            </em>
          </p>
          <p>
            {t('form.preferredContactPeriod.label')}:{' '}
            <em>{data.preferredContactPeriod}</em>
          </p>
          <p>
            {t('form.deliveryPeriod.label')}: <em>{data.deliveryPeriod}</em>
          </p>
          <p>
            {t('form.deliveryNotes.label')}: <em>{data.deliveryNotes}</em>
          </p>

          <div className="text-right">
            <EditLink onClick={() => handleEdit('delivery-info')} />
          </div>
        </Fieldset>

        <Fieldset legend={t('form.legends.paymentInfo')}>
          <p>
            {t('form.invoiceEmail.label')}: <em>{data.invoiceEmail}</em>
          </p>

          {data.enableEamElectronicInvoice ? (
            <>
              <p>
                {t('form.enableEamElectronicInvoice.label')}:{' '}
                <em>{t('confirmation.yes')}</em>
              </p>
              <p>
                {t('form.paymentRemindersEmail.label')}:{' '}
                <em>{data.paymentRemindersEmail}</em>
              </p>
            </>
          ) : (
            <p>
              {t('form.enableEamElectronicInvoice.label')}:{' '}
              <em>{t('confirmation.no')}</em>
            </p>
          )}

          <div className="text-right">
            <EditLink onClick={() => handleEdit('payment-info')} />
          </div>
        </Fieldset>
        <div className="form-check">
          <input
            id="checkTOS"
            name="checkTOS"
            type="checkbox"
            className="form-check-input"
            onChange={handleCheck}
          />
          <label htmlFor="checkTOS" className="form-check-label">
            <Trans
              i18nKey="form.checkTOS.label"
              values={{ brand: config.brand }}
            >
              <a
                href={config.tosTermsAndConditionsLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              <a
                href={config.tosPrivacyPolicyLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
            </Trans>
          </label>
        </div>

        <div className="form-check">
          <input
            id="checkPaymentTerms"
            name="checkPaymentTerms"
            type="checkbox"
            className="form-check-input"
            onChange={handleCheck}
          />
          <label htmlFor="checkPaymentTerms" className="form-check-label">
            <Trans
              i18nKey="form.checkPaymentTerms.label"
              values={{ brand: config.brand }}
            >
              <a
                href={config.checkPaymentTermsLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
            </Trans>
          </label>
        </div>

        <div className="form-check">
          <input
            id="checkNewsletterSubscription"
            name="checkNewsletterSubscription"
            type="checkbox"
            className="form-check-input"
            onChange={handleCheck}
          />
          <label
            htmlFor="checkNewsletterSubscription"
            className="form-check-label"
          >
            {t('form.checkNewsletterSubscription.label')}
          </label>
        </div>

        <div className="form-check">
          <input
            id="checkSmsReminder"
            name="checkSmsReminder"
            type="checkbox"
            className="form-check-input"
            onChange={handleCheck}
          />
          <label htmlFor="checkSmsReminder" className="form-check-label">
            {t('form.checkSmsReminder.label')}
          </label>
        </div>

        <div className="form-check">
          <input
            id="checkMarketingCommunication"
            name="checkMarketingCommunication"
            type="checkbox"
            className="form-check-input"
            onChange={handleCheck}
          />
          <label
            htmlFor="checkMarketingCommunication"
            className="form-check-label"
          >
            {t('form.checkMarketingCommunication.label')}
          </label>
        </div>
      </Content>

      <ActionBar onSubmit={handleSubmit} submitDisabled={submitDisabled} />
    </div>
  );
}

const mapStateToProps = state => ({
  data: state.signup.data,
  steps: state.signup.steps,
  errors: state.signup.errors
});

const mapDispatchToProps = dispatch => ({
  setData: data => dispatch({ type: 'SET_DATA', payload: data }),
  setCurrentStep: step =>
    dispatch({ type: 'SET_CURRENT_STEP', payload: [step, 'prev'] })
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(Summary)
);
